import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom' // if you use react-router
import TopNavigation from '../TopNavigation'
import { useFirebase, isLoaded, firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet'
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardSubtitle,
  CardText,
  Modal,
  ModalBody,
  ModalFooter,
  CardTitle,
  ButtonGroup,
  ModalHeader,
  Alert,
  Spinner,
} from 'reactstrap'
import moment from 'moment'
import 'moment/locale/fi'
import ViewColumnIcon from '@material-ui/icons/ViewColumn'
import ViewListIcon from '@material-ui/icons/ViewList'
import CalendarViewDayIcon from '@material-ui/icons/CalendarViewDay'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
// import InputLabel from '@material-ui/core/InputLabel'
import IconButton from '@material-ui/core/IconButton'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MuiButton from '@material-ui/core/Button'
// import { Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  DEFAULTABLE_VIEWS,
  clearCalendarViewChoice,
} from '../utils/useCalendarView'
import withAppconfig from '../AppContext'
import TeamsProfileSection from './Teams/TeamsProfileSection'
import mapWalletsStateToProps from '../components/state-utils'
import { CircularProgress, Dialog, Divider } from '@material-ui/core'
import { RATING_LABELS, APPINITLANG } from '../config'
// import AddCardIcon from '@material-ui/icons/AddCard'
import Typography from '@material-ui/core/Typography'
import ValidSchedule from '../components/ValidSchedule'
import { purchaseAmountCents, purchaseName } from '../utils/eventtickets'
import { subscriptionState, canChangeCard, cardChangeDeadline } from '../utils/subscriptions'
import { groupMemberships, periodAmount } from '../utils/membershipGroups'
import { cardList, cardBrandIcon, hasBrandLogo, setAddCardReturn } from '../utils/storedcards'
import { useAddCard, RECURRING_VENUE_CONSENT_VERSION } from '../utils/addcard'
import RecurringCardConsentNote from '../components/RecurringCardConsentNote'
import { useUiGet } from '../utils/useUiGet'
import { balanceFor, entriesText } from '../utils/activityEntries'

const DEFAULT_VIEW_ICONS = {
  simple: CalendarViewDayIcon,
  horizontal: ViewListIcon,
  vertical: ViewColumnIcon,
}

//import BottomNav from '../BottomNav'

const styles = {
  tranactionrow: {
    marginLeft: 5,
    marginRight: 5,
    paddingTop: 3,
    paddingBottom: 3,
    fontSize: 'small',
  },
}

const withWallet = compose(
  connect((state) => ({ auth: state.firebase.auth })),
  firestoreConnect((props) => [
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        {
          collection: 'paymentinfo',
          doc: 'saldo',
          subcollections: [{ collection: `${props.appconfig.accountkey}` }],
        },
      ],
      storeAs: 'wallets',
    },
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        {
          collection: 'paymentinfo',
          doc: 'storage',
          subcollections: [{ collection: `${props.appconfig.accountkey}` }],
        },
      ],
      storeAs: 'storages',
    },
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        {
          collection: 'memberships',
          doc: 'active',
          subcollections: [{ collection: `${props.appconfig.accountkey}` }],
        },
      ],
      storeAs: 'memberships',
    },
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        {
          collection: 'benefitcards',
          doc: 'active',
          subcollections: [{ collection: `${props.appconfig.accountkey}` }],
        },
      ],
      storeAs: 'benefitcards',
    },
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        {
          collection: 'cards',
        },
      ],
      storeAs: 'cards',
    },
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        {
          collection: 'eventtickets',
          doc: 'active',
          subcollections: [{ collection: `${props.appconfig.accountkey}` }],
        },
      ],
      storeAs: 'eventtickets',

    }
  ]),
  connect(mapWalletsStateToProps)
)

// function capitalizeFirstLetter(string) {
//   return string[0].toUpperCase() + string.slice(1)
// }

function StorageRow({ storage, selected, onClick }) {
  console.log('storagerow1', storage)
  if (!storage) return null
  console.log('storagerow2', storage)
  if (storage.separatesports) {
    const sports = Object.keys(storage.sums).filter((s) => s !== 'sum')
    return sports.map((sport) => {
      const sportlabel = sport.charAt(0).toUpperCase() + sport.slice(1)
      return (
        <CardText key={'sportstr-' + sport}>
          {sportlabel}:{' '}
          {storage.category === 'minutes'
            ? storage.sums[sport] + ' min'
            : (storage.sums[sport] / 100).toString() + ' €'}
        </CardText>
      )
    })
  } else {
    return (
      <CardText>
        {storage.label[APPINITLANG]}:{' '}
        {storage.category === 'minutes'
          ? storage.sum + ' min'
          : (storage.sum / 100).toString() + ' €'}
      </CardText>
    )
  }
}

// eslint-disable-next-line no-unused-vars
function RatingsSector({ ratings, clubid, editToggle }) {
  const { t } = useTranslation()
  if (!ratings) return null

  if (Object.keys(ratings).length === 0) {
    return <CardText>{t('no_rating')}</CardText>
  }

  return Object.keys(ratings)
    .sort()
    .map((sport) => {
      if (Object.keys(ratings[sport]).length > 0) {
        return Object.keys(ratings[sport]).map((source) => {
          let _source = source
          if (source === clubid) {
            _source = t('club_rating')
          } else if (RATING_LABELS[sport] && RATING_LABELS[sport][source]) {
            _source = RATING_LABELS[sport][source].short
          }
          return (
            <Row key={'rating-' + sport + '-' + source}>
              <Col>
                {t(sport)} - {_source}: {ratings[sport][source].value}
              </Col>
            </Row>
          )
        })
      } else {
        return (
          <Row key={'rating-' + sport}>
            <Col>
              {t(sport)} - {t('no_rating')}
            </Col>
          </Row>
        )
      }
    })
}

function RatingDialog({
  ratings,
  clubid,
  norating,
  clubrating,
  open,
  onClose,
  title,
  closeTitle,
  onSave,
  saveTitle,
}) {
  const { t } = useTranslation()
  const [selectedSport, setSelectedSport] = useState('')
  const [unsavedRatings, setUnsavedRatings] = useState(ratings)

  const onSavePress = () => {
    console.log('onSavePress')
    onSave(unsavedRatings)
  }

  useEffect(() => {
    setUnsavedRatings(ratings)
  }, [ratings])

  const hasManySources = (sport) => {
    if (!RATING_LABELS[sport]) return false
    return Object.keys(RATING_LABELS[sport]).length > 1
  }

  return (
    <Modal isOpen={open} toggle={onClose} size='lg'>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>
        {/* <CardText>{t('select_sport')}</CardText> */}
        <FormControl
          variant='outlined'
          style={{ width: '100%', marginBottom: 30 }}
        >
          <Select
            labelId={(selectedSport || 'dropdown') + '-select-label'}
            id={(selectedSport || 'dropdown') + '-select'}
            value={selectedSport}
            onChange={(e) => setSelectedSport(e.target.value)}
            style={{ width: '100%' }}
            displayEmpty
          >
            <MenuItem disabled value=''>{t('select_sport')}</MenuItem>
            {Object.keys(RATING_LABELS)
              .sort()
              .map((sport) => {
                return <MenuItem key={sport} value={sport}>{t(sport)}</MenuItem>
              })}
          </Select>
        </FormControl>
        {selectedSport && selectedSport !== '' && (
        <Row>
          <Col></Col>
          <Col>{t('external_rating_id')}</Col>
          <Col>{t('external_rating_value')}</Col>
        </Row>
        )}
        <Form className=''>
          {selectedSport &&
            selectedSport !== '' &&
            Object.keys(RATING_LABELS[selectedSport]).map((source) => {
              let _source = source
              if (source === clubid) {
                _source = clubrating
              } else if (RATING_LABELS[selectedSport][source]) {
                _source = RATING_LABELS[selectedSport][source].short
              }
              return (
                <Row key={'rating-' + selectedSport + '-' + source}>
                  <Col className='my-auto'>
                    <h6>
                      {_source} -{' '}
                      {RATING_LABELS[selectedSport][source]
                        ? RATING_LABELS[selectedSport][source].long
                        : source}
                    </h6>
                  </Col>
                  <Col>
                    <FormGroup className='loose-form'>
                      {/* <Label for='external_rating_id'> */}
                        {/* {t('external_rating_id')} * */}
                      {/* </Label> */}
                      <Input
                        aria-label={t('external_rating_id')}
                        type='text'
                        name={selectedSport + '-' + source}
                        id={'external_rating_id-' + selectedSport + '-' + source}
                        value={
                          unsavedRatings[selectedSport] &&
                          unsavedRatings[selectedSport][source]
                            ? unsavedRatings[selectedSport][source].id
                            : ''
                        }
                        onChange={(e) => {
                          const _ratings = { ...unsavedRatings }
                          if (!_ratings[selectedSport]) {
                            _ratings[selectedSport] = {}
                            _ratings[selectedSport][source] = {}
                          } else if (!_ratings[selectedSport][source]) {
                            _ratings[selectedSport][source] = {}
                          }
                          _ratings[selectedSport][source].id = e.target.value
                          setUnsavedRatings(_ratings)
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col className='my-auto'>
                    {RATING_LABELS[selectedSport][source].automatic ? (
                      <CardText>{t('fetching_automatic')}</CardText>
                    )
                      : (
                        <FormGroup className='loose-form'>
                          {/* <Label for='external_rating_value'> */}
                            {/* {t('external_rating_value')} * */}
                          {/* </Label> */}
                          <Input
                            aria-label={t('external_rating_value')}
                            type='text'
                            id={'external_rating_value-' + selectedSport + '-' + source}
                            disabled={
                              RATING_LABELS[selectedSport][source].automatic
                            }
                            name={selectedSport + '-' + source}
                            value={
                              unsavedRatings[selectedSport] &&
                                unsavedRatings[selectedSport][source]
                                ? unsavedRatings[selectedSport][source].value
                                : ''
                            }
                            onChange={(e) => {
                              const _ratings = { ...unsavedRatings }
                              if (!_ratings[selectedSport]) {
                                _ratings[selectedSport] = {}
                                _ratings[selectedSport][source] = {}
                              } else if (!_ratings[selectedSport][source]) {
                                _ratings[selectedSport][source] = {}
                              }
                              _ratings[selectedSport][source].value = e.target.value
                              setUnsavedRatings(_ratings)
                            }}
                          />
                        </FormGroup>
                      )}
                  </Col>
                </Row>
              )
            })}
        </Form>
        <Row>
          <Col style={{ marginTop: 30 }}>
            {hasManySources(selectedSport) && (
              <Alert color='info'>
                {t('rating_source_help')}
              </Alert>
            )}
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color='primary' onClick={onSavePress}>
          {saveTitle}
        </Button>{' '}
        <Button color='primary' onClick={onClose}>
          {closeTitle}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

function ProfileScreen({
  auth,
  profile,
  saldotransactions,
  memberships,
  mems,
  balances,
  accesscode,
  storages,
  benefitcards,
  storagetransactions,
  appconfig,
  gtime,
  cards,
  eventtickets
}) {
  // eslint-disable-next-line no-unused-vars
  let history = useHistory()
  const { t, i18n } = useTranslation()
  const [email, setEmail] = useState(profile.email)
  const [newemail, setNewEmail] = useState(null)
  const [newemail2, setNewEmail2] = useState(null)
  const [newpassword, setNewPassword] = useState('')
  const [newpassword2, setNewPassword2] = useState('')
  const [newpasswordErrorMessage, setNewErrorMessage] = useState('')
  const [confirmationcode, setConfirmationcode] = useState(null)
  const [firstname, setFirstname] = useState(profile.firstname)
  const [lastname, setLastname] = useState(profile.lastname)
  const [phone, setPhone] = useState(profile.phone)
  const [streetaddress, setStreetAddress] = useState(profile.streetaddress)
  const [zip, setZip] = useState(profile.zip)
  const [city, setCity] = useState(profile.city)
  const [defaultview, setDefaultView] = useState(profile.defaultview)
  const [selectedwallettype, setSelectedWalletType] = useState(null)
  const [selectedstoragetype, setSelectedStorageType] = useState(null)
  const firebase = useFirebase()
  const [cardToDelete, setCardToDelete] = useState(null)
  const [deletingCard, setDeletingCard] = useState(false)
  const [carderror, setCardError] = useState(null)
  // Continuous memberships: the assignment whose renewals are being cancelled.
  const [subscriptionToCancel, setSubscriptionToCancel] = useState(null)
  const [cancellingSubscription, setCancellingSubscription] = useState(false)
  const [subscriptionError, setSubscriptionError] = useState(null)
  // Cancelling asks the customer to type a word first ('vahvista'), so it is never a stray tap.
  const [cancelConfirmText, setCancelConfirmText] = useState('')
  const openCancelSubscription = (row) => {
    setCancelConfirmText('')
    setSubscriptionToCancel(row)
  }
  const closeCancelSubscription = () => {
    setCancelConfirmText('')
    setSubscriptionToCancel(null)
  }
  // Continuous memberships: the assignment whose card is being changed, and how the last change went.
  const [subscriptionToChangeCard, setSubscriptionToChangeCard] = useState(null)
  const [changingCard, setChangingCard] = useState(false)
  const [cardChangeMessage, setCardChangeMessage] = useState(null) // { ok, text }
  // Saldo first (a venue with appconfig.subscriptionsaldofirst): the customer may refuse it per subscription.
  const [savingSaldoChoice, setSavingSaldoChoice] = useState(false)
  // Recurring bookings paid from the saldo after play (appconfig.recurringsaldofirst): refused per venue.
  const [savingRecurringSaldo, setSavingRecurringSaldo] = useState(false)
  const [recurringSaldoError, setRecurringSaldoError] = useState(null)
  const addCardFlow = useAddCard({ appconfig })
  // Whether 'Lisää uusi kortti' was pressed in the dialog open now: addCardFlow.failed outlives the dialog,
  // and an old failure must not greet the next one.
  const [addCardTried, setAddCardTried] = useState(false)
  // the optional recurring-bookings consent for a card added from the card-change dialog, unticked by default
  const [newCardRecurringConsent, setNewCardRecurringConsent] = useState(false)
  const openCardChange = (assignment) => {
    setAddCardTried(false)
    setNewCardRecurringConsent(false)
    setCardChangeMessage(null)
    setSubscriptionToChangeCard(assignment)
  }
  // Memberships: which entries have their periods open, and whether ended ones are shown.
  const [openMemberships, setOpenMemberships] = useState({})
  // Activity entries used and left per membership product (ui-get getMembershipEntries,
  // kumpula/ACTIVITY_ENTRIES_BACKEND_CHANGES.md). Asked once the memberships are known; an older backend
  // or an error leaves it empty and the profile reads as before.
  const uiGetEntries = useUiGet({ appconfig })
  const [entryBalances, setEntryBalances] = useState(null)
  const membershipCount = Array.isArray(memberships) ? memberships.length : 0
  useEffect(() => {
    if (!uiGetEntries || !auth || !auth.uid || auth.isAnonymous || membershipCount === 0) return
    let cancelled = false
    uiGetEntries({ q: 'getMembershipEntries', customerid: appconfig.accountkey })
      .then((response) => {
        if (!cancelled && response && Array.isArray(response.data)) setEntryBalances(response.data)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth && auth.uid, membershipCount])
  const [showEndedMemberships, setShowEndedMemberships] = useState(false)

  // Stops future renewals; the membership stays valid until the end of the period already paid.
  const cancelSubscription = async (assignment) => {
    if (!assignment || cancellingSubscription) return
    setCancellingSubscription(true)
    setSubscriptionError(null)
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testui-create' : 'ui-create'
    try {
      const response = await firebase
        .functions()
        .httpsCallable(fn)({ q: 'cancelsubscription', assignmentid: assignment.id, customerid: appconfig.accountkey })
      if (response.data && response.data.error) setSubscriptionError(t('subscription_cancel_failed'))
    } catch (e) {
      setSubscriptionError(t('subscription_cancel_failed'))
    }
    setCancellingSubscription(false)
    closeCancelSubscription()
  }

  // Puts another stored card on the subscription. A failed one (charge refused) comes back with it until
  // cardChangeDeadline, and the backend charges the new period within the hour.
  const CARD_CHANGE_ERRORS = {
    card_expired: 'subscription_change_card_expired',
    charging_in_progress: 'subscription_change_card_charging',
    not_active: 'subscription_change_card_too_late',
  }
  const setSubscriptionSaldo = async (assignment, usesaldo) => {
    if (!assignment || savingSaldoChoice) return
    setSavingSaldoChoice(true)
    setCardChangeMessage(null)
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testui-create' : 'ui-create'
    try {
      const response = await firebase
        .functions()
        .httpsCallable(fn)({ q: 'setsubscriptionsaldo', assignmentid: assignment.id, customerid: appconfig.accountkey, usesaldo })
      if (!response || !response.data || response.data.error) setCardChangeMessage({ ok: false, text: t('subscription_saldo_failed') })
    } catch (e) {
      setCardChangeMessage({ ok: false, text: t('subscription_saldo_failed') })
    }
    setSavingSaldoChoice(false)
  }

  const recurringSaldoRefused = Boolean(profile && profile.recurringsaldooptout && profile.recurringsaldooptout[appconfig.accountkey] === true)
  const setRecurringSaldo = async (usesaldo) => {
    if (savingRecurringSaldo) return
    setSavingRecurringSaldo(true)
    setRecurringSaldoError(null)
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testui-create' : 'ui-create'
    try {
      const response = await firebase.functions().httpsCallable(fn)({ q: 'setrecurringsaldo', customerid: appconfig.accountkey, usesaldo })
      if (!response || !response.data || response.data.error) setRecurringSaldoError(t('recurring_saldo_failed'))
    } catch (e) {
      setRecurringSaldoError(t('recurring_saldo_failed'))
    }
    setSavingRecurringSaldo(false)
  }

  // Recurring bookings charged after play from a consented card (appconfig.recurringcardafterplay): the consent per card.
  const [cardConsentToGive, setCardConsentToGive] = useState(null)
  const [savingCardConsent, setSavingCardConsent] = useState(false)
  const setCardRecurringConsent = async (card, consent) => {
    if (!card || savingCardConsent) return
    setSavingCardConsent(true)
    setCardError(null)
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testui-create' : 'ui-create'
    try {
      const response = await firebase.functions().httpsCallable(fn)({
        q: 'setcardrecurringconsent', customerid: appconfig.accountkey, cardid: card.id, consent,
        consentversion: consent ? RECURRING_VENUE_CONSENT_VERSION : undefined,
      })
      if (!response || !response.data || response.data.error) {
        setCardError(response && response.data && response.data.message === 'card_expired' ? t('subscription_change_card_expired') : t('recurring_card_consent_failed'))
      }
    } catch (e) {
      setCardError(t('recurring_card_consent_failed'))
    }
    setSavingCardConsent(false)
    setCardConsentToGive(null)
  }

  const changeSubscriptionCard = async (assignment, cardid) => {
    if (!assignment || !cardid || changingCard) return
    setChangingCard(true)
    setCardChangeMessage(null)
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testui-create' : 'ui-create'
    try {
      const response = await firebase
        .functions()
        .httpsCallable(fn)({ q: 'changesubscriptioncard', assignmentid: assignment.id, customerid: appconfig.accountkey, cardid })
      const data = (response && response.data) || {}
      if (data.error) {
        setCardChangeMessage({ ok: false, text: t(CARD_CHANGE_ERRORS[data.message] || 'subscription_change_card_failed') })
      } else {
        setCardChangeMessage({ ok: true, text: t(data.reactivated ? 'subscription_change_card_reactivated' : 'subscription_change_card_done') })
      }
    } catch (e) {
      setCardChangeMessage({ ok: false, text: t('subscription_change_card_failed') })
    }
    setChangingCard(false)
    setSubscriptionToChangeCard(null)
  }
  // A new card for the subscription: Paytrail's add-card form, and the backend puts the card on it.
  const addCardForSubscription = (assignment) => {
    if (!assignment) return
    setAddCardTried(true)
    setAddCardReturn(appconfig.pathPrefix + '/profile')
    addCardFlow.start({ assignmentid: assignment.id, recurringConsent: newCardRecurringConsent })
  }

  const deleteCard = async (card) => {
    if (!card || deletingCard) return
    setDeletingCard(true)
    setCardError(null)
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testui-create' : 'ui-create'
    try {
      const response = await firebase
        .functions()
        .httpsCallable(fn)({ q: 'deletecard', cardid: card.id, customerid: appconfig.accountkey })
      if (response.data && response.data.error) {
        // A card that pays a continuous membership cannot go until that is cancelled.
        setCardError(response.data.message === 'card_in_use' ? t('card_delete_in_use') : t('card_delete_failed'))
      }
    } catch (e) {
      setCardError(t('card_delete_failed'))
    }
    setDeletingCard(false)
    setCardToDelete(null)
  }
  const [editOpen, setEditOpen] = useState(false)
  const [passwordMatch, setPasswordMatch] = useState(false)
  const [editEmailOpen, setEditEmailOpen] = useState(false)
  const [saveModalOpen, setSaveModalOpen] = useState(false)
  const [messageModalOpen, setMessageModalOpen] = useState(false)
  const [confirmationcodeOpen, setConfirmationcodeOpen] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [confirmationMessage, setConfirmationMessage] = useState(null)
  const [confirmationError, setConfirmationError] = useState(null)
  const [confirmProgress, setConfirmProgress] = useState(false)
  const [messagetitle, setMessageTitle] = useState(null)
  const [messagebody, setMessageBody] = useState()
  const [messagecategory, setMessageCategory] = useState('Saldot')
  // eslint-disable-next-line no-unused-vars
  const [messagethankyou, setMessageThankyou] = useState(false)
  const [membershipproducts, setMembershipProducts] = useState(null)
  const membershipProductsRequested = useRef(false)
  const [passwordModalOpen, setPasswordModalOpen] = useState(false)
  const [ratings, setRatings] = useState({})
  const [ratingDialogOpen, setRatingDialogOpen] = useState(false)
  const [customershipAdding, setCustomershipAdding] = useState(false)
  const editToggle = (state) => setEditOpen(state)
  const editEmailToggle = (state) => setEditEmailOpen(state)
  const confirmationcodeToggle = (state) => setConfirmationcodeOpen(state)
  const saveToggle = () => setSaveModalOpen(!saveModalOpen)
  const messageToggle = () => setMessageModalOpen(!messageModalOpen)


  const passwordModalToggle = () => setPasswordModalOpen(!passwordModalOpen)

  const toggleWalletType = (type) => {
    if (selectedwallettype === type) {
      setSelectedWalletType(null)
    } else {
      setSelectedWalletType(type)
    }
  }

  const toggleStorageType = (type) => {
    if (selectedstoragetype === type) {
      setSelectedStorageType(null)
    } else {
      setSelectedStorageType(type)
    }
  }

  const onSavePress = () => {
    const _p = { firstname, lastname, phone }
    if (streetaddress) _p.streetaddress = streetaddress
    if (zip) _p.zip = zip
    if (city) _p.city = city
    if (defaultview) _p.defaultview = defaultview
    return firebase.updateProfile(_p).then((result) => {
      // A view picked earlier in this browsing session outranks the profile
      // default (see useCalendarView) - drop it so the new default applies now.
      if (defaultview && defaultview !== profile.defaultview) {
        clearCalendarViewChoice(appconfig)
      }
      return result
    })
  }

  const onPasswordUpdate = (target) => {
    if (target.name === 'newpassword') {
      const strength = checkPasswordStrength()
      setNewPassword(target.value)
      if (
        target.value === newpassword2 &&
        target.value.length >= 7 &&
        strength >= 3
      ) {
        setNewErrorMessage(null)
        setPasswordMatch(true)
      } else {
        if (target.value !== newpassword2) {
          setNewErrorMessage(t('not_matching_password'))
        } else if (strength < 3) {
          setNewErrorMessage(t('too_weak_password'))
        } else {
          setNewErrorMessage(t('too_short_password'))
        }
        setPasswordMatch(false)
      }
    } else {
      const strength = checkPasswordStrength()
      setNewPassword2(target.value)
      if (
        target.value === newpassword &&
        newpassword.length >= 7 &&
        strength >= 3
      ) {
        setPasswordMatch(true)
        setNewErrorMessage(null)
      } else {
        if (target.value !== newpassword) {
          setNewErrorMessage(t('not_matching_password'))
        } else if (strength < 3) {
          setNewErrorMessage(t('too_weak_password'))
        } else {
          setNewErrorMessage(t('too_short_password'))
        }
        setPasswordMatch(false)
      }
    }
  }

  const checkPasswordStrength = () => {
    let pwdCheck = 0
    const validateRegex = ['[A-Z]', '[a-z]', '[0-9]', '\\W']
    validateRegex.forEach((regex, i) => {
      if (new RegExp(regex).test(newpassword)) {
        pwdCheck += 1
      }
    })
    return pwdCheck
  }

  const onChangePassword = () => {
    console.log('onChangePassword')
    firebase.functions().region = 'europe-west1'
    const updatePassword = firebase
      .functions()
      .httpsCallable('users-updatePassword')
    return updatePassword({ newpassword }).then((response) => {
      console.log('response.data', response.data)
      if (response.data.error) {
        setConfirmationMessage(response.data.message)
        return Promise.resolve(response.data)
      } else {
        // const message = t('password_changed')
        setNewPassword('')
        setNewPassword2('')
        passwordModalToggle()
      }
    })
  }

  const onChangeEmail = () => {
    firebase.functions().region = 'europe-west1'
    const createConfirmation = firebase
      .functions()
      .httpsCallable('users-createConfirmation')
    return createConfirmation({ cid: appconfig.accountkey, newemail }).then(
      (response) => {
        if (response.data.error) {
          setConfirmationMessage(response.data.message)
          return Promise.resolve(response.data)
        } else {
          const message = t('confirmation_send')
          setConfirmationMessage(message)
          return Promise.resolve(response.data)
        }
      }
    )
  }

  const confirmEmailChange = () => {
    return fetch(
      'https://europe-west1-falcon-328a1.cloudfunctions.net/users-confirmEmail?code=' +
        confirmationcode
    ).then((response) => {
      return Promise.resolve(response.json())
    })
  }

  const onSendPress = () => {
    let time = new Date()
    return firebase.push('supportmessages/' + auth.uid, {
      email,
      messagetitle,
      messagebody,
      send: time.toString(),
      messagecategory,
      customer: appconfig.accountkey,
    })
  }

  const getMembershipProducts = () => {
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest
      ? 'testmemberships-getmemberships'
      : 'memberships-getmemberships'
    const getmemberships = firebase.functions().httpsCallable(fn)
    getmemberships({ customerid: appconfig.accountkey })
      .then((response) => {
        let memberships = []
        if (response.data && response.data.memberships) {
          memberships = response.data.memberships
        }
        setMembershipProducts(memberships)
      })
      // Without names the list still shows; a failed call must not leave the memberships spinning.
      .catch(() => setMembershipProducts([]))
  }

    // A continuous membership's renewal state, after its validity. Nothing for an ordinary membership
    // (no status fields), so every existing row reads exactly as before.
    // One entry per membership: consecutive periods of a continuous membership are one chain
    // (utils/membershipGroups.js), with its overall validity, its renewal state and its periods -
    // each with its own receipt - folded underneath. Ended ones wait behind a link.
    const membershipEntries = () => {
      const day = (d) => (d ? moment.utc(d).format('D.M.YYYY') : '')
      const today = (gtime ? moment.utc(gtime) : moment.utc()).format('YYYY-MM-DD')
      const entries = groupMemberships(memberships, today)
      const current = entries.filter((e) => !e.ended)
      const ended = entries.filter((e) => e.ended)
      const receiptButton = (row) =>
        row.payment ? (
          <Button color='link' size='sm' onClick={() => downloadMembershipReceipt(row.id)}>
            {t('receipt')}
          </Button>
        ) : null
      const renderEntry = (e) => {
        const product = membershipproducts.find((x) => x.id === e.membershipid)
        const name = product ? product.displayName : ''
        const open = Boolean(openMemberships[e.key])
        // Cancelling sits at the end of the periods list, out of the way - so a subscription has the
        // list even with a single period.
        const activeRows = (e.stateRows || []).filter((row) => {
          const sub = subscriptionState(row)
          return sub && sub.active
        })
        const several = e.rows.length > 1 || activeRows.length > 0
        const validity = e.permanent
          ? t('membership_permanent')
          : (e.upcoming ? t('membership_starts').replace('{DATE}', day(e.start)) + ' · ' : '') +
            t('membership_valid_until').replace('{DATE}', day(e.end))
        return (
          <CardText key={e.key} style={e.ended ? { color: '#777' } : null}>
            <strong>{name}</strong>
            <br />
            {validity}{' '}
            {several ? null : receiptButton(e.rows[0])}
            {(() => {
              const balance = e.ended ? null : balanceFor(entryBalances, e.membershipid)
              if (!balance) return null
              return (
                <>
                  <br />
                  <span style={{ fontSize: 'small', color: Number(balance.remaining) === 0 ? '#b00020' : '#555' }}>
                    {entriesText(balance, t)}
                  </span>
                </>
              )
            })()}
            {/* Every active subscription (each cancellable); with none, the latest one's state. */}
            {(e.stateRows || []).map((row) => (
              <React.Fragment key={'state-' + row.id}>{subscriptionLine(row)}</React.Fragment>
            ))}
            {several ? (
              <>
                <br />
                <Button
                  color='link'
                  size='sm'
                  style={{ paddingLeft: 0 }}
                  onClick={() => setOpenMemberships({ ...openMemberships, [e.key]: !open })}
                >
                  {(open ? '▾ ' : '▸ ') + t('membership_periods') + ' (' + e.rows.length + ')'}
                </Button>
                {open
                  ? e.rows.map((row) => (
                      <div key={row.id} style={{ fontSize: 'small', paddingLeft: 12 }}>
                        {day(row.start)} – {day(row.end)}
                        {periodAmount(row) ? ' · ' + periodAmount(row) : ''} {receiptButton(row)}
                      </div>
                    ))
                  : null}
                {open
                  ? activeRows.map((row) => {
                      // Two active subscriptions of one membership: name the card so each button is clear.
                      const card = activeRows.length > 1 ? cardList(cards).find((c) => c.id === (subscriptionState(row) || {}).cardid) : null
                      return (
                        <div key={'cancel-' + row.id} style={{ paddingLeft: 12, marginTop: 6 }}>
                          <Button color='danger' size='sm' onClick={() => openCancelSubscription(row)}>
                            {t('subscription_cancel')}
                            {card ? ' · ' + card.label : ''}
                          </Button>
                        </div>
                      )
                    })
                  : null}
              </>
            ) : null}
          </CardText>
        )
      }
      return (
        <>
          {current.length > 0 ? current.map(renderEntry) : <CardText>{t('no_memberships')}</CardText>}
          {ended.length > 0 ? (
            <Button color='link' size='sm' style={{ paddingLeft: 0 }} onClick={() => setShowEndedMemberships(!showEndedMemberships)}>
              {showEndedMemberships ? t('memberships_hide_ended') : t('memberships_show_ended') + ' (' + ended.length + ')'}
            </Button>
          ) : null}
          {showEndedMemberships ? ended.map(renderEntry) : null}
        </>
      )
    }

    const subscriptionLine = (m) => {
      const sub = subscriptionState(m)
      if (!sub) return null
      const end = sub.end ? moment.utc(sub.end).format('D.M.YYYY') : ''
      if (sub.active) {
        const card = cardList(cards).find((c) => c.id === sub.cardid)
        return (
          <>
            <br />
            <span className='text-muted'>
              {t('subscription_continuous')}
              {sub.nextcharge ? ' · ' + t('subscription_next_charge') + ' ' + moment.utc(sub.nextcharge).format('D.M.YYYY') : ''}
              {card ? ' · ' + card.label : ''}
            </span>
            {appconfig.storedcards && canChangeCard(sub) ? (
              <Button color='link' size='sm' onClick={() => openCardChange(m)}>
                {t('subscription_change_card')}
              </Button>
            ) : null}
            {appconfig.subscriptionsaldofirst ? (
              <>
                <br />
                <span className='text-muted' style={{ fontSize: 'small' }}>
                  {t(sub.usesaldo ? 'subscription_saldo_first_on' : 'subscription_saldo_first_off')}
                </span>{' '}
                <Button color='link' size='sm' disabled={savingSaldoChoice} onClick={() => setSubscriptionSaldo(m, !sub.usesaldo)}>
                  {savingSaldoChoice ? <Spinner size='sm' /> : t(sub.usesaldo ? 'subscription_saldo_refuse' : 'subscription_saldo_allow')}
                </Button>
              </>
            ) : null}
          </>
        )
      }
      if (sub.cancelled) {
        return (
          <>
            <br />
            <span className='text-muted'>{t('subscription_cancelled_until').replace('{DATE}', end)}</span>
          </>
        )
      }
      if (sub.failed) {
        return (
          <>
            <br />
            <span style={{ color: '#b00020' }}>{t('subscription_failed_until').replace('{DATE}', end)}</span>{' '}
            {appconfig.storedcards && canChangeCard(sub) ? (
              <>
                <br />
                <span className='text-muted'>
                  {t('subscription_failed_change_until').replace('{DATE}', moment.utc(cardChangeDeadline(sub.end)).format('D.M.YYYY'))}
                </span>{' '}
                <Button color='link' size='sm' onClick={() => openCardChange(m)}>
                  {t('subscription_change_card')}
                </Button>
              </>
            ) : null}
            <Button color='link' size='sm' onClick={() => history.push(appconfig.pathPrefix + '/shop/membership/' + m.membershipid)}>
              {t('subscription_buy_again')}
            </Button>
          </>
        )
      }
      return null
    }

    const downloadMembershipReceipt = (id) => {
      firebase
        .auth()
        .currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          let downloadUrl =
            'https://europe-west1-falcon-328a1.cloudfunctions.net/receipt-downloadMembership?cid=' +
            appconfig.accountkey +
            '&id=' +
            id +
            '&token=' +
            idTokenResult.token
          window.open(downloadUrl, '_blank')
        })
    }

  const downloadEventticketReceipt = (id, paymenttoken) => {
    firebase
      .auth()
      .currentUser.getIdTokenResult()
      .then((idTokenResult) => {
        let downloadUrl =
          'https://europe-west1-falcon-328a1.cloudfunctions.net/receipt-downloadEventticket?cid=' +
          appconfig.accountkey +
          '&id=' +
          id +
          '&paymenttoken=' +
          paymenttoken +
          '&token=' +
          idTokenResult.token
        window.open(downloadUrl, '_blank')
      })
  }

  const addCustomership = () => {
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest
      ? 'testmemberships-addcustomership'
      : 'memberships-addcustomership'
    setCustomershipAdding(true)
    const addcustomership = firebase.functions().httpsCallable(fn)
    addcustomership({ customerid: appconfig.accountkey }).then((response) => {
      setCustomershipAdding(false)
      console.log('addCustomership response', response)
    })
  }

  const ratingDialogToggle = () => {
    setRatingDialogOpen(!ratingDialogOpen)
  }

  const onRatingSavePress = (data) => {
    const _p = { ratings: data }
    console.log('onRatingSavePress', data)
    firebase.updateProfile(_p).then(() => {
      ratingDialogToggle()
    })
  }

  const loaded =
    isLoaded(profile) &&
    isLoaded(saldotransactions) &&
    isLoaded(storagetransactions) &&
    isLoaded(mems)
  useEffect(() => {
    setEmail(profile.email)
    setFirstname(profile.firstname)
    setLastname(profile.lastname)
    setPhone(profile.phone)
    setZip(profile.zip)
    setStreetAddress(profile.address || profile.streetaddress)
    setCity(profile.city)
    setDefaultView(profile.defaultview)
    setMessageCategory('Saldot')
    setRatings(profile.ratings || {})
    // Product names are fetched once, straight away - in parallel with the memberships themselves,
    // not after them, which is what kept a direct visit on 'no memberships' for so long.
    if (!membershipproducts && !membershipProductsRequested.current) {
      membershipProductsRequested.current = true
      getMembershipProducts()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile, mems])

  const getTransactionRow = (i, first, second, third, fourth) => {
    return (
      <Row
        key={'rtrans-' + i}
        style={styles.tranactionrow}
        className='border-bottom'
      >
        <Col className='text-left' xs={'4'} sm={'2'} md={'12'} lg={'2'}>
          {first}
        </Col>
        <Col
          className='text-left'
          xs={'8'}
          sm={'6'}
          md={'12'}
          lg={'6'} /*style={{ paddingLeft: 10, paddingRight: 0 }}*/
        >
          {second}
        </Col>
        <Col xs={'6'} sm={'2'} md={'6'} lg={'2'}>
          {third}
        </Col>
        <Col xs={'6'} sm={'2'} md={'6'} lg={'2'}>
          {fourth}
        </Col>
      </Row>
    )
  }

  const _selectedWalletTransactions =
    selectedwallettype &&
    saldotransactions[selectedwallettype.venue]?.[selectedwallettype.category]
      ? saldotransactions[selectedwallettype.venue][selectedwallettype.category]
      : []
  // do some formatting for transactions
  // eslint-disable-next-line array-callback-return
  let _s = 0
  let selectedWalletTransactions = _selectedWalletTransactions
    .map((ta, i) => {
      if (ta.amount) {
        _s = _s + ta.amount
      }
      let timestamp = ta.validuntil ? (
        <>
          <div>
            {moment.utc(ta.timestamp, 'YYYY.MM.DD HH:mm').format('D.M.YY')}
          </div>
          <div style={{ fontSize: 'x-small' }}>
            {'(' +
              moment.utc(ta.validuntil, 'YYYY.MM.DD HH:mm').format('D.M.YY') +
              ')'}
          </div>
        </>
      ) : (
        moment.utc(ta.timestamp, 'YYYY.MM.DD  HH:mm').format('D.M.YY')
      )

      if (!ta.timestamp) {
        if (ta.type === 'purchase') {
          timestamp = moment
            .utc(ta.purchase.occurency, 'YYYY-MM-DD')
            .format('D.M.YY')
        }
      }

      if (ta.purchasetype === 'reservation' || ta.purchasetype === 'activity' || ta.purchasetype === 'benefitcard' || ta.purchasetype === 'match') {
        if (ta.type === 'refund') {
          return getTransactionRow(
            i,
            ta.description.startsWith('Peruttu')
              ? t('cancellation')
              : t('sell'),
            ta.description,
            timestamp,
            <>
              <div>{(ta.amount / 100).toString() + ' €'}</div>
              <div style={{ fontSize: 'x-small' }}>
                {'(' + (_s / 100).toString() + '€)'}
              </div>
            </>
          )
        } else if (ta.type === 'purchase') {
          let title = t('reservation')
          if (ta.purchasetype !== 'reservation') {
            title = t('payment')
          }
          return getTransactionRow(
            i,
            title,
            ta.description,
            timestamp,
            <>
              <div>{(ta.amount / 100).toString() + ' €'}</div>
              <div style={{ fontSize: 'x-small' }}>
                {'(' + (_s / 100).toString() + '€)'}
              </div>
            </>
          )
        }
      } else {
        let title = ''
        if (
          ta.type === 'compensation' ||
          ta.type === 'transfer' ||
          ta.type === 'deposit'
        ) {
          title = t(ta.type)
        } else {
          return <></>
        }
        return getTransactionRow(
          i,
          title,
          ta.description,
          timestamp,
          <>
            <div>{(ta.amount / 100).toString() + ' €'}</div>
            <div style={{ fontSize: 'x-small' }}>
              {'(' + (_s / 100).toString() + '€)'}
            </div>
          </>
        )
      }
      return null
    })
    .filter((ta) => ta !== null)
  selectedWalletTransactions = [...selectedWalletTransactions].reverse()
  if (_selectedWalletTransactions.length < 1 && selectedwallettype) {
    selectedWalletTransactions = (
      <Row xs={'12'} sm={'12'} md={'12'} lg={'12'}>
        <Col>{t('no_balance_transactions')}</Col>
      </Row>
    )
  }

  const _selectedStorageTransactions =
    selectedstoragetype &&
    storagetransactions[selectedstoragetype.venue]?.[
      selectedstoragetype.category
    ]
      ? storagetransactions[selectedstoragetype.venue][
          selectedstoragetype.category
        ]
      : []
  const _storageType =
    selectedstoragetype && selectedstoragetype.category
      ? selectedstoragetype.category
      : null

  // do some formatting for transactions
  let _sa = 0
  // eslint-disable-next-line array-callback-return
  let selectedStorageTransactions = _selectedStorageTransactions.map(
    (ta, i) => {
      if (ta.amount) {
        _sa = _sa + ta.amount
      }
      console.log('timestamp', ta.timestamp)

      const timestamp = ta.validuntil ? (
        <>
          <div>
            {moment.utc(ta.timestamp, 'YYYY.MM.DD HH:mm').format('D.M.YY')}
          </div>
          <div style={{ fontSize: 'x-small' }}>
            {'(' +
              moment.utc(ta.validuntil, 'YYYY.MM.DD HH:mm').format('D.M.YY') +
              ')'}
          </div>
        </>
      ) : (
        moment.utc(ta.timestamp, 'YYYY.MM.DD HH:mm').format('D.M.YY')
      )
      if (ta.type === 'refund' || ta.amount > 0) {
        return getTransactionRow(
          i,
          t('to_storage'),
          ta.description || '',
          timestamp,
          <>
            <div>
              {_storageType === 'minutes'
                ? ta.amount + ' min'
                : (ta.amount / 100).toString() + ' €'}
            </div>
            <div style={{ fontSize: 'x-small' }}>
              (
              {_storageType === 'minutes'
                ? _sa + 'min'
                : (_sa / 100).toString() + '€'}
              )
            </div>
          </>
        )
      } else if (ta.type === 'purchase' || ta.amount < 0) {
        return getTransactionRow(
          i,
          t('from_storage'),
          ta.description || '',
          timestamp,
          <>
            <div>
              {_storageType === 'minutes'
                ? ta.amount + ' min'
                : (ta.amount / 100).toString() + ' €'}
            </div>
            <div style={{ fontSize: 'x-small' }}>
              (
              {_storageType === 'minutes'
                ? _sa + 'min'
                : (_sa / 100).toString() + '€'}
              )
            </div>
          </>
        )
      } else {
        return <></>
      }
    }
  )
  selectedStorageTransactions = [...selectedStorageTransactions].reverse()
  if (_selectedStorageTransactions.length < 1 && selectedstoragetype) {
    selectedStorageTransactions = (
      <Row xs={'12'} sm={'12'} md={'12'} lg={'12'}>
        <Col>{t('no_storage_transactions')}</Col>
      </Row>
    )
  }

  // if (selectedwallettype && selectedwallettype.expiring) {
  //   const _linedate = moment().subtract(selectedwallettype.expiring, 'days')
  //   const _ed = _selectedWalletTransactions.filter((ta) => moment.utc(ta.timestamp, 'YYYY.MM.DD HH:mm').isAfter(_linedate) && ta.amount > 0).map((ta) => moment.utc(ta.timestamp, 'YYYY.MM.DD HH:mm')).sort((a, b) => a.unix() - b.unix())
  //   console.log('_ed', _ed)
  //   console.log('_selectedWalletTransactions', _selectedWalletTransactions)
  //   console.log('expiring', selectedwallettype.expiring)
  //   if (_ed.length > 0) {
  //     const linedate = _ed[0]
  //     // const linedate = ed.add(selectedwallettype.expiring, 'days')
  //     console.log('linedate', linedate.format('YYYY.MM.DD HH:mm'))
  //     // stored fund before linedate
  //     const _s = _selectedWalletTransactions.reduce((acc, ta) => {
  //       if (moment.utc(ta.timestamp, 'YYYY.MM.DD HH:mm').isSameOrBefore(linedate) && ta.amount > 0) {
  //         return acc + ta.amount
  //       } else {
  //         return acc
  //       }
  //     }, 0)

  //     // purchases after linedate
  //     const _p = _selectedWalletTransactions.reduce((acc, ta) => {
  //       if (moment.utc(ta.timestamp, 'YYYY.MM.DD HH:mm').isSameOrAfter(linedate) && ta.type === 'purchase') {
  //         return acc + ta.amount
  //       } else {
  //         return acc
  //       }
  //     }, 0)
  //     console.log('s', _s)
  //     console.log('p', _p)
  //     if (_p + _s > 0) {
  //       console.log('p-s', _p + _s)
  //       const _d = moment(linedate).add(selectedwallettype.expiring, 'days')
  //       console.log('Seuraava saldon vanhenemispäivä', _d.format('D.M.YYYY'), 'vanhenevat saldot', (_p + _s)/100, '€')
  //     }
  //   }
  // }

  const isZipValid =
    !zip ||
    (zip && zip.trim() && zip.trim().length === 5 && !isNaN(parseInt(zip)))
  const isCityValid = !city || (city && city.trim() && city.trim().length > 1)
  const isStreetValid =
    !streetaddress ||
    (streetaddress && streetaddress.trim() && streetaddress.trim().length > 6)
  const isAddressValid = isZipValid && isCityValid && isStreetValid

  if (!loaded) {
    return (
      <div className='full-page-background'>
        <TopNavigation />
        <Container className='front'>
          <Row>
            <Col md='8' className='mx-auto'>
              <div className='logo mb-3'>
                <div className='col-md-12 text-center tesoma-page-title'>
                  <h2>{t('omat_tiedot')}</h2>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md='8' className='mx-auto text-center'>
              {t('loading')}
            </Col>
          </Row>
        </Container>
      </div>
    )
  } else {
    // console.log(i18n.language)
    return (
      <div className='full-page-background'>
        <TopNavigation />
        <Container className='front'>
          <Row>
            <Col md='8' className='mx-auto'>
              <div className='logo mb-3'>
                <div className='col-md-12 text-center tesoma-page-title'>
                  <h2>{t('omat_tiedot')}</h2>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            {!editOpen ? (
              <Col md='6' className=''>
                <Card>
                  <CardBody>
                    <CardTitle tag='h5'>
                      {firstname} {lastname}
                    </CardTitle>
                    <CardSubtitle tag='h6' className='mb-2 text-muted'>
                      {t('email')}
                    </CardSubtitle>
                    <CardText>{email}</CardText>
                    <CardSubtitle tag='h6' className='mb-2 text-muted'>
                      {t('phone')}
                    </CardSubtitle>
                    <CardText>{phone || t('not_set')}</CardText>
                    <CardSubtitle tag='h6' className='mb-2 text-muted'>
                      {t('address')}
                    </CardSubtitle>
                    <CardText>{streetaddress || t('not_set')}</CardText>
                    <CardSubtitle tag='h6' className='mb-2 text-muted'>
                      {t('zip')}
                    </CardSubtitle>
                    <CardText>{zip || t('not_set')}</CardText>
                    <CardSubtitle tag='h6' className='mb-2 text-muted'>
                      {t('city')}
                    </CardSubtitle>
                    <CardText>{city || t('not_set')}</CardText>

                    {accesscode && !appconfig.donotshowaccesscode ? (
                      <>
                        {/* <Divider /> */}
                        <CardSubtitle tag='h6' className='mb-2 mt-2 text-muted'>
                          {t('accesscode')}
                        </CardSubtitle>
                        <CardText>{accesscode}</CardText>
                      </>
                    ) : null}
                    <Row style={{ marginBottom: 20 }}>
                      <Col>
                      <CardSubtitle tag='h6' className='mb-2 text-muted'>
                      {t('defaultview')}
                    </CardSubtitle>
                    <CardText>
                      {profile.defaultview ? t(profile.defaultview) : ''}
                    </CardText>
                      </Col>
                      <Col className='text-right' >
                        <Button color='primary' onClick={editToggle}>
                          {t('edit')} <EditIcon fontSize='small' />
                        </Button>
                      </Col>
                    </Row>

                    <Divider />
                    <CardSubtitle tag='h6' className='mb-2 mt-2 text-muted'>
                      {t('memberships')}
                    </CardSubtitle>
                    {/* Loading until the memberships have arrived and, when there are any, their names. */}
                    {!isLoaded(mems) || (memberships && memberships.length > 0 && !membershipproducts) ? (
                      <CardText>
                        <CircularProgress size={18} />
                      </CardText>
                    ) : memberships && memberships.length > 0 ? (
                      membershipEntries()
                    ) : (
                      <CardText>{t('no_memberships')}</CardText>
                    )}
                    {subscriptionError ? <CardText style={{ color: 'red' }}>{subscriptionError}</CardText> : null}
                    {cardChangeMessage ? (
                      <CardText style={{ color: cardChangeMessage.ok ? 'green' : 'red' }}>{cardChangeMessage.text}</CardText>
                    ) : null}
                    <Dialog open={Boolean(subscriptionToChangeCard)} onClose={() => setSubscriptionToChangeCard(null)}>
                      <div style={{ padding: 20 }}>
                        <p>{t('subscription_change_card_title')}</p>
                        {(() => {
                          // valid stored cards other than the one charged now
                          const current = (subscriptionState(subscriptionToChangeCard) || {}).cardid
                          const choices = cardList(cards).filter((c) => !c.expired && c.id !== current)
                          if (choices.length === 0) return <p className='text-muted'>{t('subscription_change_card_none')}</p>
                          return choices.map((c) => (
                            <div key={c.id} style={{ marginBottom: 6 }}>
                              <Button
                                size='sm'
                                color='primary'
                                outline
                                disabled={changingCard}
                                onClick={() => changeSubscriptionCard(subscriptionToChangeCard, c.id)}
                              >
                                {(c.type ? c.type + ' ' : '') + c.label + (c.expires ? ' · ' + c.expires : '')}
                              </Button>
                            </div>
                          ))
                        })()}
                        {changingCard ? <Spinner size='sm' /> : null}
                        <div style={{ marginTop: 12 }}>
                          <Button
                            size='sm'
                            color='primary'
                            disabled={changingCard || addCardFlow.starting}
                            onClick={() => addCardForSubscription(subscriptionToChangeCard)}
                          >
                            {addCardFlow.starting ? <Spinner size='sm' /> : t('subscription_change_card_add_new')}
                          </Button>
                          <RecurringCardConsentNote checked={newCardRecurringConsent} onChange={setNewCardRecurringConsent} />{' '}
                          <Button size='sm' color='secondary' onClick={() => setSubscriptionToChangeCard(null)}>
                            {t('subscription_change_card_cancel')}
                          </Button>
                        </div>
                        {addCardTried && addCardFlow.failed ? <p style={{ color: 'red', marginTop: 8 }}>{t('card_add_failed_init')}</p> : null}
                      </div>
                    </Dialog>
                    <Dialog open={Boolean(subscriptionToCancel)} onClose={closeCancelSubscription}>
                      <div style={{ padding: 20 }}>
                        <p>
                          {t('subscription_cancel_confirm').replace(
                            '{DATE}',
                            subscriptionToCancel && subscriptionToCancel.end ? moment.utc(subscriptionToCancel.end).format('D.M.YYYY') : ''
                          )}
                        </p>
                        <Label for='cancelconfirm' style={{ fontSize: 'small' }}>
                          {t('subscription_cancel_type').replace('{WORD}', t('subscription_cancel_word'))}
                        </Label>
                        <Input
                          id='cancelconfirm'
                          bsSize='sm'
                          autoComplete='off'
                          value={cancelConfirmText}
                          onChange={(ev) => setCancelConfirmText(ev.target.value)}
                          style={{ marginBottom: 12, maxWidth: 220 }}
                        />
                        <Button
                          size='sm'
                          color='danger'
                          disabled={
                            cancellingSubscription ||
                            cancelConfirmText.trim().toLowerCase() !== t('subscription_cancel_word').toLowerCase()
                          }
                          onClick={() => cancelSubscription(subscriptionToCancel)}
                        >
                          {cancellingSubscription ? <Spinner size='sm' /> : t('subscription_cancel_yes')}
                        </Button>{' '}
                        <Button size='sm' color='secondary' onClick={closeCancelSubscription}>
                          {t('subscription_cancel_no')}
                        </Button>
                      </div>
                    </Dialog>
                    <Divider />
                    <CardSubtitle tag='h6' className='mb-2 mt-2 text-muted'>
                      {t('cards')}
                    </CardSubtitle>
                    <CardSubtitle tag='p' className='mb-2 mt-2 text-muted'>
                      {t('activities')}
                    </CardSubtitle>
                    {benefitcards && benefitcards.length > 0
                      ? benefitcards
                          .filter((x) => x.collection === 'activities')
                          .map((benefitcard) => {
                            if (benefitcard.type === 'count') {
                              return (
                                <CardText>
                                  {benefitcard.sport} - {benefitcard.name}:{' '}
                                  {benefitcard.remaining} {t('remaining')} /{' '}
                                  {t('valid')}{' '}
                                  {moment
                                    .utc(benefitcard.validuntil)
                                    .format('D.M.YY')}{' '}
                                  {t('until')}{' '}
                                </CardText>
                              )
                            } else {
                              return (
                                <CardText>
                                  {benefitcard.sport} - {benefitcard.name}:{' '}
                                  {t('valid')}{' '}
                                  {benefitcard.lastday.format('D.M.YY')}{' '}
                                  {t('until')}{' '}
                                </CardText>
                              )
                            }
                          })
                      : null}
                    <CardSubtitle tag='p' className='mb-2 mt-2 text-muted'>
                      {t('reservation')}
                    </CardSubtitle>
                    {benefitcards && benefitcards.length > 0
                      ? benefitcards
                          .filter((x) => x.collection === 'reservations')
                          .map((benefitcard) => {
                            return (
                              <CardText>
                                {benefitcard.name}: {benefitcard.remaining}{' '}
                                {benefitcard.type === 'count' ? t('counts') : t('minutes')} {t('remaining').toLowerCase()}{' / '}
                                { t('valid')}{' '}
                                {moment
                                  .utc(benefitcard.validuntil)
                                  .format('D.M.YY')}{' '}
                                {t('until')}{' '}
                              </CardText>
                            )
                          })
                      : null}

                    <Divider />
                    {appconfig.allowcreatematches ? (
                    <> <CardSubtitle tag='h6' className='mb-2 mt-2 text-muted'>
                      {t('ratings')}
                    <IconButton color='primary' onClick={ratingDialogToggle}>
                      <EditIcon fontSize='small' />
                    </IconButton>
                    </CardSubtitle>

                    <RatingsSector
                      ratings={ratings}
                      clubid={appconfig.accountkey}
                      // norating={t('no_rating')}
                      // clubrating={t('club_rating')}
                      editToggle={ratingDialogToggle}
                        />
                        
                    <Divider style={{ marginTop: 20 }} /></>) : null}
                    <CardSubtitle tag='h6' className='mb-2 mt-2 text-muted'>
                      {t('eventtickets')}
                    </CardSubtitle> 
                    <>
                      {eventtickets.map((ticket) => (
                        <CardText key={'et-' + ticket.id}>
                          <b>{ticket.name} - {moment.utc(ticket.start).format('D.M.YY')}{' '}</b>
                          {ticket.purchases.map((p) => (
                            <>
                            <div key={'etp-' + p.id}> 
                              {/* An admin-added purchase has only `price`: see utils/eventtickets.js. */}
                              {purchaseName(p, ticket)}: {p.quantity} kpl,{' '}{purchaseAmountCents(p) !== null ? (purchaseAmountCents(p) / 100).toFixed(2) + '€' : ''}{' '}{ticket.pdfs && ticket.pdfs.find((pdf) => pdf.id === p.paymenttoken) ? <a href={ticket.pdfs.find((pdf) => pdf.id === p.paymenttoken).pdfurl} target='_blank' rel='noreferrer'>Lataa lippu</a> : 'Lataus ei saatavilla'} 
                                {/* A free ticket (0 €, e.g. one an admin added) has nothing to give a receipt for. */}
                                {purchaseAmountCents(p) !== 0 && ticket.payments.find((pay) => pay.paymenttoken === p.paymenttoken) ? <Button
                                    color='link'
                                    size='sm'
                                    onClick={() => downloadEventticketReceipt(p.id, p.paymenttoken)}
                                  >
                                    {t('receipt')}
                                  </Button> : null}
                              </div>
                            </> 
                          ))}
                        </CardText>
                      ))}
                    </>
                    <Divider style={{ marginBottom: 10 }} />
                    {appconfig.storedcards ? (
                    <>
                    <CardSubtitle tag='h6' className='mb-2 mt-2 text-muted'>
                      {t('storedcards')}
                    </CardSubtitle>
                    {cards && cards.length > 0 ? (
                      cards.map((card) => (
                        <CardText key={card.id}>
                          {/* The card's brand logo (Visa, Mastercard, Amex); Paytrail's for anything else. */}
                          <img src={process.env.PUBLIC_URL + cardBrandIcon(card)} alt={card.card.type || card.provider} style={{ height: 20, verticalAlign: 'middle', marginRight: 6 }} />
                          {hasBrandLogo(card) ? '' : card.card.type + ' '}**** {card.card.partial_pan} { card.card.expire_month + '/' + card.card.expire_year} {card.card.funding}
                          <IconButton
                            size='small'
                            aria-label={t('delete_card')}
                            disabled={deletingCard}
                            onClick={() => setCardToDelete(card)}
                          >
                            <DeleteIcon fontSize='small' />
                          </IconButton>
                          {appconfig.recurringcardafterplay ? (
                            <>
                              <br />
                              <span className='text-muted' style={{ fontSize: 'small' }}>
                                {t(card.recurringconsent && card.recurringconsent[appconfig.accountkey] ? 'recurring_card_consent_on' : 'recurring_card_consent_off')}
                              </span>{' '}
                              {card.recurringconsent && card.recurringconsent[appconfig.accountkey] ? (
                                <Button color='link' size='sm' disabled={savingCardConsent} onClick={() => setCardRecurringConsent(card, false)}>
                                  {t('recurring_card_consent_withdraw')}
                                </Button>
                              ) : (
                                <Button color='link' size='sm' disabled={savingCardConsent} onClick={() => setCardConsentToGive(card)}>
                                  {t('recurring_card_consent_give')}
                                </Button>
                              )}
                            </>
                          ) : null}
                        </CardText>
                      ))
                    ) : (
                      <CardText>{t('no_stored_cards')}</CardText>
                    )}
                    {carderror ? <CardText style={{ color: 'red' }}>{carderror}</CardText> : null}
                    <Button
                      size='sm'
                      color='link'
                      style={{ padding: 0 }}
                      onClick={() => history.push(appconfig.pathPrefix + '/addcard')}
                    >
                      {t('add_card')}
                    </Button>
                    <Dialog open={Boolean(cardConsentToGive)} onClose={() => setCardConsentToGive(null)}>
                      <div style={{ padding: 20 }}>
                        <p>{t('recurring_card_venue_consent_give')}</p>
                        <Button size='sm' color='primary' disabled={savingCardConsent} onClick={() => setCardRecurringConsent(cardConsentToGive, true)}>
                          {savingCardConsent ? <Spinner size='sm' /> : t('recurring_card_consent_accept')}
                        </Button>{' '}
                        <Button size='sm' color='secondary' onClick={() => setCardConsentToGive(null)}>
                          {t('cancel')}
                        </Button>
                      </div>
                    </Dialog>
                    <Dialog open={Boolean(cardToDelete)} onClose={() => setCardToDelete(null)}>
                      <div style={{ padding: 20 }}>
                        <p>{t('delete_card_confirm')}</p>
                        <Button
                          size='sm'
                          color='danger'
                          disabled={deletingCard}
                          onClick={() => deleteCard(cardToDelete)}
                        >
                          {deletingCard ? <Spinner size='sm' /> : t('delete_card')}
                        </Button>{' '}
                        <Button size='sm' color='secondary' onClick={() => setCardToDelete(null)}>
                          {t('cancel')}
                        </Button>
                      </div>
                    </Dialog>
                    <Divider style={{ marginTop: 10 }} />
                    </>
                    ) : null}
                    {/* Renders nothing unless this venue has teams on AND this person
                        manages one, so an ordinary customer's profile is unchanged. */}
                    <TeamsProfileSection appconfig={appconfig} />
                    <CardSubtitle tag='h6' className='mb-2 mt-2 text-muted'>
                      {t('balance')}
                    </CardSubtitle>
                    {balances.map((balance, i) => (
                      <React.Fragment key={'balance-' + i}>
                        <CardText>
                          {balance.label[APPINITLANG]}: {balance.sum / 100} €
                        </CardText>
                        {balance.nextexpiring ? (
                          <CardText>
                            {balance.nextexpiring +
                              ' ' +
                              t('next_balance_expiring') +
                              ' ' +
                              balance.nextexpiringamount +
                              ' €'}
                          </CardText>
                        ) : null}
                      </React.Fragment>
                    ))}
                    {appconfig.recurringsaldofirst ? (
                      <CardText style={{ fontSize: 'small' }}>
                        {t(recurringSaldoRefused ? 'recurring_saldo_off' : 'recurring_saldo_on')}{' '}
                        <Button color='link' size='sm' style={{ padding: 0 }} disabled={savingRecurringSaldo} onClick={() => setRecurringSaldo(recurringSaldoRefused)}>
                          {savingRecurringSaldo ? <Spinner size='sm' /> : t(recurringSaldoRefused ? 'recurring_saldo_allow' : 'recurring_saldo_refuse')}
                        </Button>
                        {recurringSaldoError ? <span style={{ color: 'red' }}> {recurringSaldoError}</span> : null}
                      </CardText>
                    ) : null}
                    {storages ? (
                      <CardSubtitle tag='h6' className='mb-2 text-muted'>
                        {t('storage')}
                      </CardSubtitle>
                    ) : null}
                    {storages
                      ? storages.map((storage, i) => (
                          <StorageRow
                            storage={storage}
                            key={'storage-row-' + i}
                          />
                          // <CardText>
                          //   {storage.label[APPINITLANG]}:{' '}
                          //   {storage.category === 'minutes'
                          //     ? storage.sum + ' min'
                          //     : (storage.sum / 100).toString() + ' €'}
                          // </CardText>
                        ))
                      : null}
                    <Divider style={{ marginBottom: 30 }} />
                    {/* {accesscode && !appconfig.donotshowaccesscode ? (
                      <>
                        <Divider />
                        <CardSubtitle tag='h6' className='mb-2 mt-2 text-muted'>
                          {t('accesscode')}
                        </CardSubtitle>
                        <CardText>{accesscode}</CardText>
                      </>
                    ) : null}
                    <CardSubtitle tag='h6' className='mb-2 text-muted'>
                      {t('defaultview')}
                    </CardSubtitle>
                    <CardText>
                      {profile.defaultview ? t(profile.defaultview) : ''}
                    </CardText> */}
                    <Row className='align-items-end'>
                      <Col>
                        <Button color='primary' onClick={editToggle}>
                          {t('change_password')} <EditIcon fontSize='small' />
                        </Button>
                      </Col>
                      <Col className='text-right'>
                        <Button
                          size='sm'
                          color='primary'
                          onClick={confirmationcodeToggle}
                        >
                          {t('confirmation_code')}{' '}
                          <SettingsEthernetIcon fontSize='small' />
                        </Button>
                      </Col>
                    </Row>
                    {profile && profile._tags && profile._tags.includes(appconfig.accountkey) ? null : (
                      <Row style={{ marginTop: 20 }}>
                        <Col>
                          <Typography variant='body2' color='textSecondary' component='p' gutterBottom>
                            {t('not_customership_club')}
                          </Typography>
                          <Button
                            color='success'

                            onClick={addCustomership}
                            disabled={customershipAdding}
                          >
                            {customershipAdding ? <CircularProgress /> : t('add_customership_for_club')}{' '}
                            {/* <AddCardIcon fontSize='small' /> */}
                          </Button>
                        </Col>
                      </Row>)}
                  </CardBody>
                </Card>
                    
              </Col>
            ) : (
              <Col md='6' className=''>
                <Form className=''>
                  <FormGroup className='loose-form'>
                    <Label for='firstname'>{t('first_name')} *</Label>
                    <Input
                      type='text'
                      name='firstname'
                      id='firstname'
                      placeholder='Etunimi'
                      value={firstname}
                      autoComplete={'given-name'}
                      onChange={(event) => setFirstname(event.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className='loose-form'>
                    <Label for='lastname'>{t('last_name')} *</Label>
                    <Input
                      type='text'
                      name='lastname'
                      id='lastname'
                      placeholder='Sukunimi'
                      value={lastname}
                      autoComplete={'family-name'}
                      onChange={(event) => setLastname(event.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className='loose-form'>
                    <Label for='phone'>{t('phone')} *</Label>
                    <Input
                      type='text'
                      name='phone'
                      id='phone'
                      value={phone}
                      placeholder='Puhelin'
                      autoComplete={'tel'}
                      onChange={(event) => setPhone(event.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className='loose-form'>
                    <Label for='streetaddress'>{t('address')}</Label>
                    <Input
                      invalid={!isStreetValid}
                      type='text'
                      name='streetaddress'
                      id='streetaddress'
                      value={streetaddress}
                      placeholder=''
                      autoComplete={'address'}
                      onChange={(event) => setStreetAddress(event.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className='loose-form'>
                    <Label for='zip'>{t('zip')}</Label>
                    <Input
                      invalid={!isZipValid}
                      type='text'
                      name='zip'
                      id='zip'
                      value={zip}
                      placeholder=''
                      autoComplete={'zip'}
                      onChange={(event) => setZip(event.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className='loose-form'>
                    <Label for='city'>{t('city')}</Label>
                    <Input
                      invalid={!isCityValid}
                      type='text'
                      name='city'
                      id='city'
                      value={city}
                      placeholder=''
                      autoComplete={'city'}
                      onChange={(event) => setCity(event.target.value)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for='defaultview'>{t('defaultview')}</Label>{' '}
                    <Select
                      id='defaultview'
                      value={defaultview || ''}
                      onChange={(event) => setDefaultView(event.target.value)}
                      displayEmpty
                    >
                      {DEFAULTABLE_VIEWS.map((v) => {
                        const Icon = DEFAULT_VIEW_ICONS[v]
                        return (
                          <MenuItem value={v} key={v}>
                            <Icon
                              style={
                                defaultview === v
                                  ? { color: 'rgba(0,0,0,1)' }
                                  : { color: 'rgba(0,0,0,0.54)' }
                              }
                            />
                            {t(v)}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormGroup>
                  <Button
                    style={{ marginBottom: 40 }}
                    color='primary'
                    block
                    disabled={
                      !(firstname && lastname && phone && isAddressValid)
                    }
                    onClick={() =>
                      onSavePress().then((result) => {
                        saveToggle()
                        editToggle(false)
                      })
                    }
                  >
                    {t('save')}
                  </Button>

                  <FormGroup className='loose-form'>
                    <Label for='newpassword'>
                      <small>{t('password_guide')}</small>
                    </Label>
                    <Label for='newpassword'>{t('new_password')}</Label>
                    <Input
                      type='password'
                      name='newpassword'
                      id='newpassword'
                      autoComplete={'new-password'}
                      value={newpassword}
                      // invalid={newpassword && !passwordMatch}
                      onChange={(event) => onPasswordUpdate(event.target)}
                    />
                    <Label for='newpassword2'>{t('new_password_again')}</Label>
                    <Input
                      type='password'
                      name='newpassword2'
                      id='newpassword2'
                      // invalid={newpassword && !passwordMatch}
                      autoComplete={'new-password'}
                      value={newpassword2}
                      onChange={(event) => onPasswordUpdate(event.target)}
                    />
                  </FormGroup>
                  <Button
                    color={newpassword && !passwordMatch ? 'danger' : 'primary'}
                    onClick={onChangePassword}
                    disabled={!passwordMatch}
                    style={{ marginBottom: 40 }}
                  >
                    {newpassword && !passwordMatch
                      ? newpasswordErrorMessage
                      : t('change_password')}
                  </Button>

                  <FormGroup className='loose-form'>
                    <Label for='email'>{t('email')}</Label>
                    <Input
                      type='email'
                      name='email'
                      id='email'
                      value={email}
                      placeholder='Sähköpostiosoite'
                      autoComplete={'email'}
                      disabled
                    />
                  </FormGroup>
                  <Button color='primary' onClick={editEmailToggle}>
                    {t('change_email')} <EditIcon fontSize='small' />
                  </Button>
                </Form>
              </Col>
            )}
            <Col md={6} className='text-center'>
              <Card style={{ marginTop: 0 }}>
                {appconfig.invoices ? (
                  <React.Fragment>
                    <CardBody>
                      <MuiButton
                        fullWidth
                        variant='text'
                        onClick={() =>
                          history.push(appconfig.pathPrefix + '/invoices')
                        }
                      >
                        {t('invoices')}
                      </MuiButton>
                    </CardBody>
                    <Divider style={{ marginTop: 20 }} />
                  </React.Fragment>
                ) : null}
                <CardBody>
                  <CardTitle>{t('balance_sheet')}</CardTitle>
                </CardBody>
                {appconfig.balances.map((c) => {
                  if (
                    selectedwallettype &&
                    selectedwallettype.category === c.category &&
                    selectedwallettype.venue === c.venue
                  ) {
                    return (
                      <MuiButton
                        startIcon={<ExpandLessIcon />}
                        fullWidth
                        key={c.category + '-' + c.venue}
                        variant='text'
                        onClick={() => toggleWalletType(c)}
                      >
                        {c.label[APPINITLANG]}
                      </MuiButton>
                    )
                  } else {
                    return (
                      <MuiButton
                        startIcon={<ExpandMoreIcon />}
                        fullWidth
                        key={c.category + '-' + c.venue}
                        variant='text'
                        onClick={() => toggleWalletType(c)}
                      >
                        {c.label[APPINITLANG]}
                      </MuiButton>
                    )
                  }
                })}
                {selectedWalletTransactions}
                <Divider style={{ marginTop: 20 }} />
                {appconfig.storages ? (
                  <React.Fragment>
                    <CardBody>
                      <CardTitle>{t('storage_events')}</CardTitle>
                    </CardBody>
                    <ButtonGroup
                      size={'sm'}
                      style={{
                        marginLeft: 20,
                        marginRight: 20,
                        marginBottom: 30,
                      }}
                    >
                      {appconfig.storages.map((c) => {
                        const isactive =
                          selectedstoragetype &&
                          selectedstoragetype.category === c.category &&
                          selectedstoragetype.venue === c.venue
                        return (
                          <MuiButton
                            startIcon={
                              isactive ? <ExpandLessIcon /> : <ExpandMoreIcon />
                            }
                            fullWidth
                            key={c.category + '-' + c.venue}
                            variant='text'
                            onClick={() => toggleStorageType(c)}
                          >
                            {c.label[APPINITLANG]}
                          </MuiButton>
                          // <Button
                          //   active={isactive}
                          //   outline
                          //   key={c.category + '-' + c.venue}
                          //   color='primary'
                          //   onClick={() => toggleStorageType(c)}
                          // >
                          //   {c.label[APPINITLANG]}
                          // </Button>
                        )
                      })}
                    </ButtonGroup>
                    {selectedStorageTransactions}
                    <Divider style={{ marginTop: 20 }} />
                  </React.Fragment>
                ) : null}
                {appconfig.sportmoney && appconfig.sportmoney.length > 0 ? (
                  <CardBody className='mb-5'>
                    <CardTitle>{t('add_balance')}</CardTitle>
                    <div
                      style={{ cursor: 'pointer', height: 30 }}
                      onClick={() =>
                        history.push(appconfig.pathPrefix + '/addbalance')
                      }
                    >
                      {appconfig.sportmoney.map((c) => (
                        <img
                          src={
                            process.env.PUBLIC_URL + '/imgs/' + c + '_logo.svg'
                          }
                          alt='add balance'
                          style={{ height: '100%', marginLeft: 15 }}
                        />
                      ))}
                    </div>
                  </CardBody>
                ) : null}
                {/* <CardBody>
                  {messagethankyou ? (
                    <>{t('help.part2')}</>
                  ) : (
                    <>
                      {t('help.part1')} <br />
                      <Button size='sm' color='info' style={{ marginTop: 5 }} onClick={messageToggle}>
                        {t('send_message')}
                      </Button>
                    </>
                  )}
                </CardBody> */}
              </Card>
            </Col>
            {/* </Row>
            </Col> */}
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col>
              <Row>
                {appconfig.infotexts ? (
                  <Col md={12} className='text-center'>
                    <Card style={{ marginTop: 10 }}>
                      <CardBody>
                        <p>
                          {appconfig.infotexts.part1
                            ? appconfig.infotexts.part1[i18n.language] ||
                              appconfig.infotexts.part1['fi']
                            : null}
                        </p>
                        <p>
                          {appconfig.infotexts.part2
                            ? appconfig.infotexts.part2[i18n.language] ||
                              appconfig.infotexts.part2['fi']
                            : null}
                        </p>

                        {appconfig.infotexts.part3
                          ? appconfig.infotexts.part3[i18n.language] ||
                            appconfig.infotexts.part3['fi']
                          : null}
                      </CardBody>
                    </Card>
                  </Col>
                ) : null}
              </Row>
            </Col>
          </Row>

          <Modal isOpen={passwordModalOpen} toggle={passwordModalToggle}>
            <ModalBody>{t('password_changed')}</ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={passwordModalToggle}>
                {t('close')}
              </Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={saveModalOpen} toggle={saveToggle}>
            <ModalBody>
              <div>{t('saved')}</div>
            </ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={saveToggle}>
                Sulje
              </Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={messageModalOpen} toggle={messageToggle}>
            <ModalBody>
              <Form className=''>
                <FormGroup className='loose-form'>
                  <Label for='message-email'>{t('email')}</Label>
                  <Input
                    type='email'
                    name='email'
                    id='message-email'
                    value={email}
                    placeholder='Sähköpostiosoite'
                    autoComplete={'email'}
                    disabled
                  />
                </FormGroup>
                <FormGroup className='loose-form'>
                  <Label for='messagecategory'>
                    {t('supportmessage_topic')}
                  </Label>
                  <Input
                    type='messagecategory'
                    name='messagecategory'
                    id='messagecategory'
                    value={messagecategory}
                    disabled
                  />
                </FormGroup>
                <FormGroup className='loose-form'>
                  <Label for='messagetitle'>{t('supportmessage_title')}</Label>
                  <Input
                    type='text'
                    name='messagetitle'
                    id='messagetitle'
                    placeholder={t('supportmessage_title')}
                    value={messagetitle}
                    onChange={(event) => setMessageTitle(event.target.value)}
                  />
                </FormGroup>
                <FormGroup className='loose-form'>
                  <Label for='messagebody'>{t('supportmessage_body')}</Label>
                  <Input
                    type='textarea'
                    name='messagebody'
                    id='messagebody'
                    placeholder={t('supportmessage_body')}
                    rows={10}
                    value={messagebody}
                    onChange={(event) => setMessageBody(event.target.value)}
                  />
                </FormGroup>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button color='secondary' onClick={messageToggle}>
                {t('cancel')}
              </Button>
              <Button
                color='primary'
                onClick={() =>
                  onSendPress().then((result) => {
                    setMessageThankyou(true)
                    setMessageBody(null)
                    setMessageTitle(null)
                    messageToggle()
                  })
                }
              >
                {t('send')}
              </Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={editEmailOpen} toggle={editEmailToggle}>
            <ModalHeader>{t('email')}</ModalHeader>
            <ModalBody>{t('password_change_info')}</ModalBody>
            <ModalBody>
              <Form>
                <FormGroup className='loose-form'>
                  <Label for='passwordchange-email'>{t('email')}</Label>
                  <Input
                    type='email'
                    name='email'
                    id='passwordchange-email'
                    value={email}
                    placeholder='Sähköpostiosoite'
                    autoComplete={'email'}
                    disabled
                  />
                </FormGroup>
                <FormGroup className='loose-form'>
                  <Label for='newemail'>{t('new_email')}</Label>
                  <Input
                    invalid={(newemail || newemail2) && newemail !== newemail2}
                    valid={(newemail || newemail2) && newemail === newemail2}
                    type='newemail'
                    name='newemail'
                    id='newemail'
                    value={newemail}
                    placeholder={t('email')}
                    autoComplete={'email'}
                    onChange={(event) => setNewEmail(event.target.value)}
                  />
                </FormGroup>
                <FormGroup className='loose-form'>
                  <Label for='newemail2'>{t('new_email_again')}</Label>
                  <Input
                    invalid={(newemail || newemail2) && newemail !== newemail2}
                    valid={(newemail || newemail2) && newemail === newemail2}
                    type='newemail2'
                    name='newemail2'
                    id='newemail2'
                    value={newemail2}
                    placeholder={t('email')}
                    autoComplete={'email'}
                    onChange={(event) => setNewEmail2(event.target.value)}
                  />
                </FormGroup>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button
                color='secondary'
                disabled={confirmProgress}
                onClick={() => {
                  setNewEmail(null)
                  setNewEmail2(null)
                  setConfirmationcode(null)
                  editEmailToggle(false)
                  setConfirmationError(null)
                  setConfirmProgress(false)
                }}
              >
                {t('cancel')}
              </Button>
              <Button
                color='danger'
                disabled={
                  !(email && newemail && newemail2 && email !== newemail) ||
                  confirmProgress
                }
                onClick={() => {
                  setConfirmProgress(true)
                  onChangeEmail().then((result) => {
                    setNewEmail(null)
                    setNewEmail2(null)
                    setConfirmationcode(null)
                    setConfirmationError(null)

                    editEmailToggle(false)
                    editToggle(false)
                    confirmationcodeToggle(true)
                    setConfirmProgress(false)
                  })
                }}
              >
                {confirmProgress ? <Spinner size={'sm'} /> : t('save')}
              </Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={confirmationcodeOpen} toggle={confirmationcodeToggle}>
            <ModalHeader>{t('confirmation_code')}</ModalHeader>
            <ModalBody>{t('confirmation_code_info')}</ModalBody>
            {confirmationError ? (
              <ModalBody>
                <Alert color='danger'>{confirmationError}</Alert>
              </ModalBody>
            ) : null}
            <ModalBody>
              <Form>
                <FormGroup className='loose-form'>
                  <Label for='confirmationcode'>{t('confirmation_code')}</Label>
                  <Input
                    type='confirmationcode'
                    name='confirmationcode'
                    id='confirmationcode'
                    value={confirmationcode}
                    autoComplete={'confirmation_code'}
                    onChange={(event) =>
                      setConfirmationcode(event.target.value)
                    }
                  />
                </FormGroup>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button
                color='secondary'
                onClick={() => {
                  setNewEmail(null)
                  setNewEmail2(null)
                  setConfirmationcode(null)
                  editEmailToggle(false)
                  setConfirmationError(null)
                  confirmationcodeToggle(false)
                }}
              >
                {t('cancel')}
              </Button>
              <Button
                color='danger'
                disabled={!confirmationcode || confirmProgress}
                onClick={() => {
                  setConfirmProgress(true)
                  confirmEmailChange().then((result) => {
                    if (result.error) {
                      setConfirmationError(result.message.fi)
                      setConfirmProgress(false)
                    } else {
                      setNewEmail(null)
                      setNewEmail2(null)
                      setConfirmationcode(null)
                      setConfirmationError(null)

                      confirmationcodeToggle(false)
                      editToggle(false)
                      setConfirmProgress(false)
                    }
                  })
                }}
              >
                {confirmProgress ? <Spinner size={'sm'} /> : t('confirm')}
              </Button>
            </ModalFooter>
          </Modal>
          <RatingDialog
            open={ratingDialogOpen}
            onClose={ratingDialogToggle}
            title={t('ratings')}
            closeTitle={t('close')}
            onSave={onRatingSavePress}
            saveTitle={t('save')}
            ratings={ratings}
          />
        </Container>
      </div>
    )
  }
}

export default withAppconfig(withWallet(ProfileScreen))
